var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button, Checkbox, Dimmer, Input, Loader, Select } from "semantic-ui-react";
import { fetchRnaCatalog, RelevantCatalogType } from "../kit/rna-cish/RnaCatalog";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { CatalogMode } from "../RequestHelpers";
var AddUserAmplifierConfigModal = /** @class */ (function (_super) {
    __extends(AddUserAmplifierConfigModal, _super);
    function AddUserAmplifierConfigModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onProtocolChange = function (event, data) {
            var protocolType = data.value;
            _this.setState({
                protocolType: protocolType === "LEICA" ? {
                    label: "Leica",
                    id: "LEICA",
                    alias: "Bond"
                } : (protocolType === "ROCHE" ? {
                    id: "ROCHE",
                    label: "Roche",
                    alias: "Discovery"
                } : (protocolType === "ONCORE_PRO_X" ? {
                    id: "ONCORE_PRO_X",
                    label: "ONCORE Pro X",
                    alias: "ONCORE Pro X"
                } : {
                    id: "MANUAL",
                    label: "Manual",
                    alias: "Manual"
                }))
            });
        };
        _this.onDisplayNameChange = function (event, data) {
            var val = data.value;
            _this.setState({
                displayName: val
            });
        };
        _this.onVisibleChange = function (event, data) {
            var checked = data.checked === true;
            _this.setState({ visible: checked });
        };
        _this.onAmplifierChange = function (event, data) {
            var val = data.value;
            if (typeof (val) !== 'string') {
                throw new Error("Unexpected value " + val);
            }
            _this.setState({
                amplifier: val
            });
        };
        _this.onHaptenChange = function (event, data) {
            var val = data.value;
            if (typeof (val) !== 'string') {
                throw new Error("Unexpected value " + val);
            }
            _this.setState({
                hapten: val
            });
        };
        _this.onAntiHapten1Change = function (event, data) {
            var val = data.value;
            if (typeof (val) !== 'string') {
                throw new Error("Unexpected value " + val);
            }
            _this.setState({
                antiHapten1: val
            });
        };
        _this.onTyramideHaptenChange = function (event, data) {
            var val = data.value;
            if (typeof (val) !== 'string') {
                throw new Error("Unexpected value " + val);
            }
            _this.setState({
                tyramideHapten: val
            });
        };
        _this.onAntiHapten2ApChange = function (event, data) {
            var val = data.value;
            if (typeof (val) !== 'string') {
                throw new Error("Unexpected value " + val);
            }
            _this.setState({
                antiHapten2Ap: val
            });
        };
        _this.onAntiHapten2HrpChange = function (event, data) {
            var val = data.value;
            if (typeof (val) !== 'string') {
                throw new Error("Unexpected value " + val);
            }
            _this.setState({
                antiHapten2Hrp: val
            });
        };
        _this.submit = function () {
            var bodyToSerialize = {};
            bodyToSerialize = __assign(__assign({}, bodyToSerialize), { displayName: _this.state.displayName, protocolType: _this.state.protocolType.id, amplifier: _this.state.amplifier, hapten: _this.state.hapten, antiHapten1: _this.state.antiHapten1, tyramideHapten: _this.state.tyramideHapten, visible: _this.state.visible });
            if (_this.state.antiHapten2Ap !== "NONE" && _this.state.antiHapten2Ap != null) {
                bodyToSerialize = __assign(__assign({}, bodyToSerialize), { antiHapten2Ap: _this.state.antiHapten2Ap });
            }
            if (_this.state.antiHapten2Hrp !== "NONE" && _this.state.antiHapten2Hrp != null) {
                bodyToSerialize = __assign(__assign({}, bodyToSerialize), { antiHapten2Hrp: _this.state.antiHapten2Hrp });
            }
            _this.props.postRequest("/admin/catalog/rna-cish/user-amplifier-catalog", bodyToSerialize);
        };
        _this.loadRelevantCatalog = function () {
            _this.setState({
                catalogLoading: true
            }, function () {
                fetchRnaCatalog(CatalogMode.Internal, RelevantCatalogType.Initial)
                    .then(function (catalog) {
                    _this.setState({
                        catalog: catalog,
                        catalogLoading: false
                    });
                });
            });
        };
        _this.state = {
            protocolType: {
                id: "LEICA",
                label: "Leica",
                alias: "Bond"
            },
            displayName: '',
            amplifier: '',
            hapten: '',
            antiHapten1: '',
            tyramideHapten: '',
            antiHapten2Ap: '',
            antiHapten2Hrp: '',
            visible: false,
            catalogLoading: false
        };
        return _this;
    }
    AddUserAmplifierConfigModal.prototype.componentDidMount = function () {
        this.loadRelevantCatalog();
    };
    AddUserAmplifierConfigModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, null,
            React.createElement(Dimmer, { active: this.state.catalogLoading, inverted: true },
                React.createElement(Loader, null)),
            this.state.catalog &&
                React.createElement(React.Fragment, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/protocolType', labelContent: 'Protocol Type' },
                        React.createElement(Select, { options: [
                                {
                                    text: "Leica",
                                    value: "LEICA"
                                },
                                {
                                    text: "Roche",
                                    value: "ROCHE"
                                },
                                {
                                    text: "ONCORE Pro X",
                                    value: 'ONCORE_PRO_X'
                                },
                                {
                                    text: "Manual",
                                    value: 'MANUAL'
                                }
                            ], onChange: this.onProtocolChange, value: this.state.protocolType.id })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/name', labelContent: 'Display Name' },
                        React.createElement(Input, { onChange: this.onDisplayNameChange, value: this.state.displayName })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/amplifier', labelContent: 'amplifier' },
                        React.createElement(Select, { options: this.state.catalog.cishAmplifier.hcrAmplifiers.map(function (a) { return ({
                                text: a.id,
                                value: a.id
                            }); }), onChange: this.onAmplifierChange, value: this.state.amplifier })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/hapten', labelContent: 'Hapten' },
                        React.createElement(Select, { options: this.state.catalog.cishAmplifier.hapten.map(function (h) { return ({
                                text: h.name,
                                value: h.id
                            }); }), onChange: this.onHaptenChange, value: this.state.hapten })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/antiHapten1', labelContent: 'Antibody Hapten 1' },
                        React.createElement(Select, { options: this.state.catalog.cishAmplifier.antiHapten1.map(function (a) { return ({
                                text: a.label,
                                value: a.id
                            }); }), onChange: this.onAntiHapten1Change, value: this.state.antiHapten1 })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/tyramideHapten', labelContent: 'Hapten Conjugated To Tyramide' },
                        React.createElement(Select, { options: this.state.catalog.cishAmplifier.tyramideHapten.map(function (h) { return ({
                                text: h.label,
                                value: h.id
                            }); }), onChange: this.onTyramideHaptenChange, value: this.state.tyramideHapten })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/antiHapten2Ap', labelContent: 'Antibody Hapten 2 AP' },
                        React.createElement(Select, { options: this.state.catalog.cishAmplifier.antiHapten2Ap.map(function (a) { return ({
                                text: a.label,
                                value: a.id
                            }); }).concat([{ text: "NONE", value: "NONE" }]), onChange: this.onAntiHapten2ApChange, value: this.state.antiHapten2Ap })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/antiHapten2Hrp', labelContent: 'Antibody Hapten 2 HRP' },
                        React.createElement(Select, { options: this.state.catalog.cishAmplifier.antiHapten2Hrp.map(function (a) { return ({
                                text: a.label,
                                value: a.id
                            }); }).concat([{ text: "NONE", value: "NONE" }]), onChange: this.onAntiHapten2HrpChange, value: this.state.antiHapten2Hrp })),
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/visibility', errors: this.props.state.errors, labelContent: 'Visibility' },
                        React.createElement(Checkbox, { onChange: this.onVisibleChange, value: this.state.visible ? 1 : 0 })),
                    React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', labelPosition: 'left', label: 'Add User Amplifier Config', onClick: this.submit, positive: true })));
    };
    return AddUserAmplifierConfigModal;
}(React.PureComponent));
export default AddUserAmplifierConfigModal;
//# sourceMappingURL=AddUserAmplifierConfigModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddUserAmplifierConfigModal.js
// module id = 1328
// module chunks = 0